/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Members_Confirm_Reset_TitleInputs */



/**
* | output |
* | --- |
* | "Reset Credentials" |
*
* @param {Members_Confirm_Reset_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const members_confirm_reset_title = /** @type {((inputs?: Members_Confirm_Reset_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Members_Confirm_Reset_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Anmeldeinformationen zurücksetzen")
	return /** @type {LocalizedString} */ ("Reset Credentials")
});